import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { goBack, push } from "connected-react-router";
import { func, bool } from "prop-types";
import { compose } from "redux";

import { actions as loginActions } from "reducers/login";

import Button from "pages/_components/Button";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import I18n from "pages/_components/I18n";

class StepCIP extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isMobile: bool.isRequired,
    };

    handleButtonClick = () => () => {
        const { dispatch } = this.props;
        dispatch(push("/onboarding/step1"));
    };

    onHeaderBack = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    };

    onHeaderClose = () => {
        const { dispatch } = this.props;
        dispatch(loginActions.reset());
    };

    render() {
        const { isMobile } = this.props;

        return (
            <Fragment>
                <Head title="onboarding.stepCIP.title" onBack={isMobile && this.onHeaderBack} />
                <MainContainer>
                    <I18n component="h3" id="onboarding.stepCIP.importantInfo" />{" "}
                    <I18n component="p" id="onboarding.stepCIP.info1" />{" "}
                    <I18n component="h3" componentProps={{ className: "mt-8" }} id="onboarding.stepCIP.info2" />{" "}
                    <I18n component="p" id="onboarding.stepCIP.info3" />{" "}
                    <I18n component="span" id="onboarding.stepCIP.info4" />{" "}
                    <div className="form-actions">
                        <Button
                            bsStyle="primary"
                            label="global.continue"
                            type="button"
                            onClick={this.handleButtonClick()}
                            block
                        />
                    </div>
                </MainContainer>
            </Fragment>
        );
    }
}

export default compose(connect(null))(StepCIP);
